import { Component, OnInit, NgModule, ViewChild, AfterViewInit, ViewChildren } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { AppdataService } from 'src/app/services/services/appdata.service';
import { ActivatedRoute, Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { LoginserviceService } from 'src/app/services/services/loginservice.service';
import { ErrorStateMatcher, ShowOnDirtyErrorStateMatcher } from '@angular/material/core';
import myData from '../../../../assets/timezone.json';

import { data } from 'jquery';

@Component({
  selector: 'app-addcompany',
  templateUrl: './addcompany.component.html',
  styleUrls: ['./addcompany.component.css']
})
@NgModule({
  providers: [
    { provide: ErrorStateMatcher, useClass: ShowOnDirtyErrorStateMatcher }
  ]
})

export class AddcompanyComponent implements OnInit, AfterViewInit {

  @ViewChildren('input') firstipcontrol;

  @ViewChild('documentbar', { static: false }) documentbar;

  formname: string = "Company";
  trxtype: string = "COMPANY";

  //Display
  formmode: string = "Add";

  //Mode Values
  isaddmode: boolean = false;
  iseditmode: boolean = false;
  isdeletemode: boolean = false;
  isviewmode: boolean = false;

  isloading: boolean = false;
  isprivilage: boolean = false;
  showProgress: boolean = false;


  //Save Validation
  submitted: boolean;
  successfully: boolean;
  saveloading: boolean;

  //Edit Get Values
  companyColl: any = [];
  companyBO: any = {};
  companyid: number = 0
  currencyColl: any = [];
  bankbranchColl: any = [];
  payrollColl: any = [];
  weekstartdayColl: any = [];
  timeZoneNames: any = [];
  companyform = new FormGroup({
    companyid: new FormControl(0),
    companycode: new FormControl('', Validators.required),
    companyname: new FormControl('', Validators.required),
    address: new FormControl(''),
    phone: new FormControl(''),
    email: new FormControl(''),
    website: new FormControl(''),
    logoimgpath: new FormControl(''),
    pan: new FormControl(''),
    tan: new FormControl(''),
    tds: new FormControl(''),
    pf: new FormControl(''),
    esi: new FormControl(''),
    gst: new FormControl(''),
    bankbranchid: new FormControl(null),
    accountno: new FormControl(''),
    iban: new FormControl(''),
    descr: new FormControl(''),
    currency: new FormControl(''),
    timezone: new FormControl(''),
    payrolltype: new FormControl(''),
    logoimage: new FormControl(null),
    signatureimage: new FormControl(null),
    address1: new FormControl(''),
    address2: new FormControl(''),
    city: new FormControl(''),
    state: new FormControl(''),
    pincode: new FormControl(''),
    weekstartday: new FormControl(''),
    currencyid: new FormControl(null),


  });

  editformtype: string = "";



  //set image
  image;
  strImage: any;
  picurl: string = "";
  picname: string = "";


  signatureimage;
  signaturestrImage: any;
  signaturepicurl: string = "";
  signaturepicname: string = "";
  bankname: string = "";


  constructor(private appService: AppdataService, private loginService: LoginserviceService, private route: ActivatedRoute,
    public router: Router, private toastr: ToastrService, private productFindService: NgbModal) {
    this.route.queryParams.subscribe(params => {
      if (params.id !== undefined) {
        this.companyid = params.id
      }
    });

    this.fnServiceChanges();
  }


  fnServiceChanges() {
    this.loginService.serviceAuthChange.subscribe((value) => {
      if (this.loginService.fnCheckCompany()) {
        if (this.fnCheckUserPririvilage()) {
          this.isloading = true;
          this.fnOnInitForm();
        }
        else {
          this.fnUserFailedForm();
        }
      }
      else {
        this.fnUserFailedForm();
      }

    });
  }



  ngOnInit() {
    try {
      if (this.loginService.fnCheckCompany()) {
        if (this.fnCheckUserPririvilage()) {
          this.isloading = true;
          this.fnOnInitForm();

        }
        else {
          this.fnUserFailedForm();
        }
      }
      else {
        this.loginService.fnGetUserRoleList();
      }

    } catch (ex) {
      this.fnShowErrorMsg(ex);
    }
    // console.log(moment.tz.names());
  }

  fnOnInitForm() {
    try {
      this.isaddmode = true;
      this.companyform.reset();
      this.fnInitializeFormGroup();

      if (this.companyid > 0) {
        this.fngetCompany();
      }
      this.fngetBankbranch();
      this.fngetCurrency();

      this.fnGetPayrollType();
      this.fngetWeekStartDay();
      this.fngetTimezone();
    } catch (ex) {
      this.fnShowErrorMsg(ex);
    }
  }
  fnCheckUserPririvilage() {
    var _check: boolean = false;
    if (this.companyid > 0) {
      _check = this.loginService.fnCheckUserRoleAction(this.formname, 'ALTER')
    } else {
      _check = this.loginService.fnCheckUserRoleAction(this.formname, 'CREATE')
    }

    return _check;
  }

  fnUserFailedForm() {
    this.isprivilage = true;
  }
  ngAfterViewInit()
  {
    this.loginService.fnSetFirstControlFocus('txtfirst');
  }
  fnInitializeFormGroup() {
    this.companyform.setValue({
      companyid: 0,
      companycode: '',
      companyname: '',
      address: '',
      phone: '',
      email: '',
      website: '',
      logoimgpath: '',
      pan: '',
      tan: '',
      tds: '',
      pf: '',
      esi: '',
      gst: '',
      bankbranchid: '',
      accountno: '',
      iban: '',
      descr: '',
      currency: '',
      timezone: '',
      payrolltype: '',
      logoimage: null,
      signatureimage: null,
      address1: '',
      address2: '',
      city: '',
      state: '',
      pincode: '',
      weekstartday: '',
      currencyid: null,


    })
  }

  //Get 
  fnGetPayrollType() {
    this.payrollColl.push({ value: 'IN', displayname: 'INDIA' });
    this.payrollColl.push({ value: 'ME', displayname: 'UAE' });
  }

  fngetBankbranch() {
    var data = {
      'bankbranch': this.companyid,
    }
    this.appService.getBankbranch(data)
      .subscribe(
        (res) => {
          this.bankbranchColl = res.json().result;

        },
        (err) => {
          this.toastr.error('Error', err);
        })
  }
  fngetCurrency() {
    var data = {
      'currencyid': 0,
      'companyid': this.loginService.fnGetCompanyId(),
    }
    this.appService.getCurrency(data)
      .subscribe(
        (res) => {
          if (res.json().status === 200) {
            this.currencyColl = res.json().result;
          } else {
            this.loginService.fnAPIError(res.json())
          }
        },
        (err) => {
          this.toastr.error('Error', err);
        })
  }

  fngetTimezone() {
    this.timeZoneNames = myData;


  }

  fngetCompany() {
    if (this.showProgress) {
      return;
    }
    var data = {
      'companyid': this.companyid,
    }
    this.appService.getCompany(data)
      .subscribe(
        (res) => {
          this.companyColl = res.json().result;
          var editdata = this.companyColl[0];
          this.fnEditMode(editdata);
          this.companyBO = editdata;
          this.fnHideProgress();


          this.documentbar.trxtype = this.trxtype;
          this.documentbar.trxid = this.companyid;
          this.documentbar.formname = this.formname;
          this.documentbar.fnGetDocument();
        },
        (err) => {
          this.fnHideProgress();

          this.toastr.error('Error', err);
        })
  }

  fngetWeekStartDay() {
    this.weekstartdayColl.push({ value: 'SUN', displayname: 'SUNDAY' });
    this.weekstartdayColl.push({ value: 'MON', displayname: 'MONDAY' });
    this.weekstartdayColl.push({ value: 'TUE', displayname: 'TUESDAY' });
    this.weekstartdayColl.push({ value: 'WED', displayname: 'WEDNESDAY' });
    this.weekstartdayColl.push({ value: 'THU', displayname: 'THURSDAY' });
    this.weekstartdayColl.push({ value: 'FRI', displayname: 'FRIDAY' });
    this.weekstartdayColl.push({ value: 'SAT', displayname: 'SATURDAY' });
  }

  //Save Btn Click
  fnSaveBtnClick() {
    try {
      if (this.saveloading) {
        return;
      }
      this.submitted = true;
      this.successfully = false;
      //Validate
      if (this.companyform.valid) {
        console.log(data)
        //Check
        this.saveloading = true;

        var data = {
          'companyid': this.companyid,
          'companycode': this.companyform.get('companycode').value,
          'companyname': this.companyform.get('companyname').value,
          'address': this.companyform.get('address').value,
          'address1': this.companyform.get('address1').value,
          'address2': this.companyform.get('address2').value,
          'city': this.companyform.get('city').value,
          'state': this.companyform.get('state').value,
          'pincode': this.companyform.get('pincode').value,
          'phone': this.companyform.get('phone').value,
          'email': this.companyform.get('email').value,
          'website': this.companyform.get('website').value,
          logoimage: this.strImage,
          logoimgpath: this.picurl,
          signatureimage: this.signaturestrImage,
          signatureimgpath: this.signaturepicurl,
          'pan': this.companyform.get('pan').value,
          'tan': this.companyform.get('tan').value,
          'tds': this.companyform.get('tds').value,
          'pf': this.companyform.get('pf').value,
          'esi': this.companyform.get('esi').value,
          'gst': this.companyform.get('gst').value,
          'bankbranchid': this.companyform.get('bankbranchid').value,
          'accountno': this.companyform.get('accountno').value,
          'iban': this.companyform.get('iban').value,
          'descr': this.companyform.get('descr').value,
          'currency': this.companyform.get('currency').value,
          'timezone': this.companyform.get('timezone').value,
          'payrolltype': this.companyform.get('payrolltype').value,
          'weekstartday': this.companyform.get('weekstartday').value,
          'currencyid': this.companyform.get('currencyid').value,
          'createdby': this.loginService.fnGetModUserId(),
          'modifiedby': this.loginService.fnGetModUserId(),
        }


        this.appService.fnCheckCompany(data).subscribe(
          (res) => {
            var _checkresult = res.json().result[0].checkfield;

            if (_checkresult === "done") {
              if (this.companyform.get('companyid').value > 0) {
                //Update 
                this.fnSetCompany(data);
              }
              else {
                //Insert 
                this.fnInsertCompany(data);
              }
            }
            else {
              if (_checkresult === "code") {
                this.saveloading = false;

                this.companyform.controls['companycode'].setErrors({ 'notfound': true });
              }
            }
          },
          (err) => {
            this.saveloading = false;

            this.toastr.error('Error', err);
          });
      }
    } catch (ex) {
      this.saveloading = false;

      this.fnShowErrorMsg(ex);
    }
  }

  //Insert
  fnInsertCompany(data) {

    this.appService.fnInsertCompany(data).subscribe(
      (res) => {
        this.saveloading = false;

        if (res.json().result != "") {
          this.toastr.success('', "The new company has been added successfully.Insert Successfully");
          this.fnInsertActivityLog('INSERT', 0, data.companyname);
          this.fnCloseForm();
        }
      },
      (err) => {
        this.saveloading = false;

        this.toastr.error('Error', err);
      });

  }

  //Set
  fnSetCompany(data) {

    this.appService.fnSetCompany(data).subscribe(
      (res) => {
        this.saveloading = false;

        if (res.json().result != "") {
          this.toastr.success('', "The company has been updated successfully.");
          this.fnInsertActivityLog('EDIT', this.companyid, data.companyname);
          this.fnCloseForm();
        }
      },
      (err) => {
        this.saveloading = false;

        this.toastr.error('Error', err);
      });

  }

  //Close
  fnCloseForm() {
    try {
      this.router.navigate(['/Company']);
    } catch (ex) {
      this.fnShowErrorMsg(ex);
    }
  }

  fnchangeBankBranch() {
    var _bankbranchid = 0;
    _bankbranchid = this.companyform.get('bankbranchid').value;
    for (let row of this.bankbranchColl) {
      if (row.bankbranchid === _bankbranchid) {
        this.bankname = row.bankname;
      }
    }
  }

  private fnEditMode(deptBO) {

    this.companyform.setValue({
      companyid: deptBO.companyid,
      companycode: deptBO.companycode,
      companyname: deptBO.companyname,
      address: deptBO.address,
      phone: deptBO.phone,
      email: deptBO.email,
      website: deptBO.website,
      logoimgpath: deptBO.logoimgpath,
      pan: deptBO.pan,
      tan: deptBO.tan,
      tds: deptBO.tds,
      logoimage: null,
      signatureimage: null,
      pf: deptBO.pf,
      esi: deptBO.esi,
      gst: deptBO.gst,
      bankbranchid: deptBO.bankbranchid,
      accountno: deptBO.accountno,
      iban: deptBO.iban,
      descr: deptBO.descr,
      currency: deptBO.currency,
      timezone: deptBO.timezone,
      payrolltype: deptBO.payrolltype,
      address1: deptBO.address1,
      address2: deptBO.address2,
      city: deptBO.city,
      state: deptBO.state,
      pincode: deptBO.pincode,
      weekstartday: deptBO.weekstartday,
      currencyid: deptBO.currencyid,


    });

    this.picurl = deptBO.logoimgpath;

    this.signaturepicurl = deptBO.signaturepath;

   
    this.formmode = "Edit";

    this.isaddmode = false;
    this.iseditmode = false;
    this.isdeletemode = false;
    this.isviewmode = true;

  }


  fnTabHeaderClick(type) {

    this.editformtype = type;

  }

  fnEditBtnClick() {
    this.iseditmode = true;

    this.isviewmode = false;
  }

  //Image Import
  changeListener($event): void {
    try {
      this.readThis($event.target);
    } catch (ex) {
      this.fnShowErrorMsg(ex);
    }
  }

  readThis(inputValue: any): void {

    var file: File = inputValue.files[0];
    var myReader: FileReader = new FileReader();

    myReader.onloadend = (e) => {
      this.image = myReader.result;
      this.strImage = this.image.split(',')[1];
    }
    myReader.readAsDataURL(file);
  }

  removeimage() {
    this.image = null;
    this.strImage = null;
    this.picurl = "";
  }

  fnOpenFileBrowser(event: any) {

    event.preventDefault();

    let element: HTMLElement = document.getElementById('image') as HTMLElement;
    element.click();

  }



  //Signature Import
  changeListenerSignature($event): void {
    try {
      this.readThisSignature($event.target);
    } catch (ex) {
      this.fnShowErrorMsg(ex);
    }
  }

  readThisSignature(inputValue: any): void {

    var file: File = inputValue.files[0];


    var myReader: FileReader = new FileReader();


    myReader.onloadend = (e) => {
      this.signatureimage = myReader.result;
      this.signaturestrImage = this.signatureimage.split(',')[1];

    }
    myReader.readAsDataURL(file);
  }

  removeimageSignature() {
    this.signatureimage = null;
    this.signaturestrImage = null;
    this.signaturepicurl = "";
  }

  fnOpenFileBrowserSignature(event: any) {

    event.preventDefault();

    let element: HTMLElement = document.getElementById('signatureimage') as HTMLElement;
    element.click();

  }



  fnInsertActivityLog(action, refno, desc) {
    try {
      var data = {
        logtype: action,
        logat: this.formname,
        refnum: refno,
        logdescr: desc,
        logby: this.loginService.fnGetModUserId(),
      }


      this.appService.fnInsertActivity(data).subscribe(
        (res) => {
        },
        (err) => {

        });

    } catch {

    }
  }
  private fnShowProgress() {
    this.showProgress = true;
  }
  private fnHideProgress() {
    this.showProgress = false;
  }

  private fnShowErrorMsg(ex) {
    this.toastr.warning('Internal Error', ex);
  }



}
